/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentMarketplace,
  AgentMarketplace$inboundSchema,
} from "./agentmarketplace.js";
import { AgentPlugin, AgentPlugin$inboundSchema } from "./agentplugin.js";
import {
  AgentPollingPrincipal,
  AgentPollingPrincipal$inboundSchema,
} from "./agentpollingprincipal.js";
import {
  DeviceAgentConfiguration,
  DeviceAgentConfiguration$inboundSchema,
} from "./deviceagentconfiguration.js";

export type GetPluginsResult = {
  /**
   * Versioned organization-wide settings delivered to enrolled device agents. Agents must ignore unknown config keys. Remote settings override the shareable local/MDM settings after a successful fetch; per-device identity and secrets always remain local.
   */
  configuration?: DeviceAgentConfiguration | undefined;
  /**
   * Opaque revision identifier covering the marketplace, plugin, remote-configuration, and organization-gateway set. The agent stores this to detect changes between polls.
   */
  etag: string;
  /**
   * Plugin marketplaces the agent should register with the tools it manages. Sorted by name.
   */
  marketplaces: Array<AgentMarketplace>;
  /**
   * URL of the active organization's gateway. Absent when the organization gateway is unavailable.
   */
  organizationGatewayUrl?: string | undefined;
  /**
   * Plugins for the caller: the observability plugin of each listed marketplace, when enabled, and the plugins assigned to the caller. Each entry's install_mode says whether the agent installs it (`required`, `default`) or only offers it for the user to turn on (`available`). Each entry references one of the marketplaces above by name.
   */
  plugins: Array<AgentPlugin>;
  principal?: AgentPollingPrincipal | undefined;
};

/** @internal */
export const GetPluginsResult$inboundSchema: z.ZodMiniType<
  GetPluginsResult,
  unknown
> = z.pipe(
  z.object({
    configuration: z.optional(DeviceAgentConfiguration$inboundSchema),
    etag: z.string(),
    marketplaces: z.array(AgentMarketplace$inboundSchema),
    organization_gateway_url: z.optional(z.string()),
    plugins: z.array(AgentPlugin$inboundSchema),
    principal: z.optional(AgentPollingPrincipal$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "organization_gateway_url": "organizationGatewayUrl",
    });
  }),
);

export function getPluginsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetPluginsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetPluginsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetPluginsResult' from JSON`,
  );
}
